import BreadCrumb from '../../components/template/BreadCrumb';
import Header from '../../components/template/Header';
import GalleryTabs from './GalleryTabs';

const GalleryPage = () => {
  return (
    <div className='pace-done gallery-form-bg'>
      <div>
        <Header />
        <BreadCrumb
          title='Add Gallery'
          mainLinkTitle='Gallery'
          mainLinkUrl='/gallery'
          activeLink='Add Gallery'
        />
        <GalleryTabs />
      </div>
    </div>
  );
};

export default GalleryPage;
